module.exports = __webpack_public_path__ + "media/mindwell-logo/mindwell-logo-gray-v2-91c1ed08.svg";